document.addEventListener('DOMContentLoaded', function () {
  // AOS Animation
  gsap.registerPlugin(ScrollTrigger);

  setTimeout(() => {
    if (typeof ScrollTrigger !== 'undefined') {
      initAOSAnimations();
      initOppositeHoverMotion();
    } else {
      console.warn('ScrollTrigger not available, please refresh the page');
    }
  }, 100);

  const params = new URLSearchParams(window.location.search);

  if (params.get('contact_posted') === 'true') {
    window.location.replace('/pages/thank-you'); // your redirect
  }

  document.querySelectorAll('.faq-section__accordion').forEach((faqSection) => {
    const detailsElements = faqSection.querySelectorAll('details');

    detailsElements.forEach((details) => {
      details.addEventListener('toggle', function () {
        if (details.open) {
          // Close all others in the same section
          detailsElements.forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
        }
      });
    });
  });

  // Collection Tab
  const tabs = document.querySelectorAll('.collection-header-tab[data-tab]');
  const panels = document.querySelectorAll('.collection-tab-panel');

  if (tabs.length > 0) {

    function scrollToTarget(element) {
      const isMobile = window.innerWidth <= 768;

      let offsetTop;

      if (isMobile) {
        // Scroll so the tab itself is visible
        offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 100; 
      } else {
        // Desktop fixed offset
        const content = document.querySelector('.collection-tab__content');
        offsetTop = content.getBoundingClientRect().top + window.pageYOffset - 250;
      }

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const tabIndex = this.getAttribute('data-tab');

        // Update tabs
        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        // Update panels
        panels.forEach((panel, index) => {
          if (index == tabIndex) {
            panel.classList.add('active');
            panel.removeAttribute('hidden');
          } else {
            panel.classList.remove('active');
            panel.setAttribute('hidden', '');
          }
        });

        scrollToTarget(this); // <<< pass the clicked tab
      });

      // Keyboard navigation
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const nextTab = this.nextElementSibling || tabs[0];
          nextTab.focus();
          nextTab.click();
        }

        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prevTab = this.previousElementSibling || tabs[tabs.length - 1];
          prevTab.focus();
          prevTab.click();
        }
      });
    });
  }


  // Star Rating
  const starRating = document.querySelectorAll('.star-rating');
  
  if (starRating.length > 0) {
    starRating.forEach(container => {
      const rating = parseFloat(container.dataset.rating) || 0;

      for (let i = 1; i <= 5; i++) {
        const star = document.createElement('div');
        star.className = 'star';

        const inner = document.createElement('div');
        inner.className = 'star-inner';

        const fill = Math.max(0, Math.min(1, rating - (i - 1))) * 100;
        inner.style.width = fill + '%';

        star.appendChild(inner);
        container.appendChild(star);
      }
    });
  }

  // Logo Carousel
  const logoSwiper = new Swiper('.js-logo__container', {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 24,
    speed: 5000,
    autoplay: {
      delay: 0,
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 5
      },
      1440: {
        slidesPerView: 6
      }
    },
  });

  // Featured Content
  const contents = document.querySelectorAll('.featured-content__grid .content');
  if (contents.length > 0 && window.innerWidth > 1023) {
    contents[0].classList.add('active');
  
    contents.forEach(content => {
      content.addEventListener('mouseenter', function() {
        contents.forEach(c => c.classList.remove('active'));
        this.classList.add('active');
      });
    });

    document.querySelector('.featured-content__grid').addEventListener('mouseleave', function() {
      const activeContent = document.querySelector('.content.active');
      if (!activeContent) {
        contents[0].classList.add('active');
      }
    }); 
  }

  // Testimonial Slider
  const testimonialSwiper = new Swiper('.js-testimonial-slider-swiper', {
    loop: true,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 20,
        slidesOffsetBefore: 50,
        slidesOffsetAfter: 50
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 32,
        slidesOffsetBefore: 50,
        slidesOffsetAfter: 50
      },
      1440: {
        slidesPerView: 2,
        spaceBetween: 32,
        slidesOffsetBefore: 100,
        slidesOffsetAfter: 100
      }
    },
  });

  const collectionTabSwiper = new Swiper('.js-collection-tab-swiper', {
    slidesPerView: 1.25,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2.25,
        spaceBetween: 20
      },
      1440: {
        slidesPerView: 3.25,
        spaceBetween: 32
      }
    },
  });

  // Image Features Slider
  const imageFeaturesSlider = new Swiper('.js-image-features-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });  

  const searchToggle = document.querySelector('.search-toggle');
  const fullWidthSearch = document.querySelector('.full-width-search');
  const searchClose = document.querySelector('.search-close-button');
  
  if (searchToggle && fullWidthSearch) {
    searchToggle.addEventListener('click', function() {
      fullWidthSearch.classList.add('active');
      const searchInput = fullWidthSearch.querySelector('.search__input');
      if (searchInput) searchInput.focus();
    });
    
    if (searchClose) {
      searchClose.addEventListener('click', function() {
        fullWidthSearch.classList.remove('active');
      });
    }
    
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && fullWidthSearch.classList.contains('active')) {
        fullWidthSearch.classList.remove('active');
      }
    });
  }

  const header = document.querySelector('.header-wrapper'); // change selector if needed
  const scrollClass = 'scrolled'; // class to add on scroll

  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) { // adjust scroll distance
      header.classList.add(scrollClass);
    } else {
      header.classList.remove(scrollClass);
    }
  });

  // PDP Media Gallery
  const productMediaGallery = document.querySelector('.js-product-media-swiper');

  if (productMediaGallery) {
    const productMediaGalleryThumbSwiper = new Swiper('.js-product-media-thumb-swiper', {
      slidesPerView: 4,
      spaceBetween: 8,
      watchSlidesProgress: true,
    });
    const productMediaGallerySwiper = new Swiper('.js-product-media-swiper', {
      slidesPerView: 1,
      spaceBetween: 8,
      thumbs: {
        swiper: productMediaGalleryThumbSwiper,
      },
    });
  }
  
  const showForm = document.querySelector('.js-show-form');

  if (showForm) {
    showForm.addEventListener('click', function(e) {
      e.preventDefault();
      const contactForm = document.querySelector('.product-info__form');
      contactForm.classList.add('show');
    })
  }

  const partInput = document.querySelector('.filter-part-input');

  if (partInput) {
    partInput.addEventListener('input', (event) => {
      event.stopPropagation(); // ⚠️ prevents Dawn from seeing the input
      const query = partInput.value.toLowerCase();
      const products = document.querySelectorAll('.product-card');

      products.forEach(card => {
        const titleEl = card.querySelector('.product-card__meta');
        const titleText = titleEl ? titleEl.innerText.toLowerCase() : ''; // fallback to empty string
        // Hide if doesn't include query
        titleText.includes(query) ? card.classList.remove('hidden') : card.classList.add('hidden');
      });
    });
  }



  const collectionListMobile = document.querySelectorAll('.js-content--mobile');

  if (collectionListMobile.length > 0) {
    collectionListMobile.forEach(item => {
      item.addEventListener('click', () => {

        // Remove active from all
        collectionListMobile.forEach(el => el.classList.remove('active'));

        // Add active to clicked
        item.classList.add('active');

      });
    });
  }

  // document.querySelectorAll('form.newsletter-custom-form').forEach(form => {
  //   form.addEventListener('submit', () => {
  //     form.querySelectorAll('input, button').forEach(el => el.disabled = true);
  //     const button = form.querySelector('[data-loading-button]');
  //     if (button) {
  //       button.classList.add('is-loading');
  //       button.setAttribute('aria-busy', 'true');
  //     }
  //   });
  // });

});

// function initAOSAnimations() {
//   const elements = gsap.utils.toArray('[class*="aos--"]');

//   const directionOffsets = {
//     'aos--up':    { y: 100 },
//     'aos--down':  { y: -100 },
//     'aos--left':  { x: 100 },
//     'aos--right': { x: -100 },
//   };

//   // Create Intersection Observer for elements already in view
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         const el = entry.target;
//         const dirClass = Object.keys(directionOffsets).(cls =>
//           el.classList.contains(cls)
//         );

//         const fromVars = {
//           opacity: 0,
//           ...(directionOffsets[dirClass] || {})
//         };

//         // Animate immediately and unobserve
//         gsap.fromTo(el, fromVars, {
//           x: 0,
//           y: 0,
//           opacity: 1,
//           duration: 1.2,
//           ease: 'power2.out'
//         });
        
//         observer.unobserve(el);
//       }
//     });
//   }, {
//     threshold: 0.1
//   });

//   elements.forEach((el) => {
//     const rect = el.getBoundingClientRect();
//     const isAlreadyInView = rect.top < window.innerHeight && rect.bottom > 0;

//     if (isAlreadyInView) {
//       // Observe elements already in view
//       observer.observe(el);
//     } else {
//       // Use ScrollTrigger for elements not in view
//       const dirClass = Object.keys(directionOffsets).(cls =>
//         el.classList.contains(cls)
//       );

//       const fromVars = {
//         opacity: 0,
//         ...(directionOffsets[dirClass] || {})
//       };

//       gsap.fromTo(
//         el,
//         fromVars,
//         {
//           x: 0,
//           y: 0,
//           opacity: 1,
//           duration: 1.2,
//           ease: 'power2.out',
//           scrollTrigger: {
//             trigger: el,
//             start: 'top 85%',
//             toggleActions: 'play none none none',
//             once: true,
//             markers: false
//           }
//         }
//       );
//     }
//   });
// }

function initAOSAnimations() {
  // Just use Intersection Observer - way more reliable
  const elements = gsap.utils.toArray('[class*="aos--"]');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('aos-animate');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });
  
  elements.forEach(el => observer.observe(el));
}

function initOppositeHoverMotion() {
  const parents = document.querySelectorAll(".parent-aoh--parallax");
  const cards = document.querySelectorAll(".aoh--parallax");

  parents.forEach((parent) => {
    parent.addEventListener("mousemove", (e) => {
      const rect = parent.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const offsetX = ((x / rect.width) - 0.5) * -10; // negative = opposite direction
      const offsetY = ((y / rect.height) - 0.5) * -10;

      cards.forEach((card) => {
        gsap.to(card, {
          x: offsetX,
          y: offsetY,
          ease: "power2.out",
          duration: 0.6,
          overwrite: 'auto',
        });
      });
    });

    parent.addEventListener("mouseleave", () => {
      cards.forEach((card) => {
        gsap.to(card, {
          x: 0,
          y: 0,
          ease: "power3.out",
          duration: 0.6,
        });
      });
    });
  });
}

